import React from "react";
import Cookies from "js-cookie";
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from "react-router-dom";
import { EndPoints } from "../../../../utils/apiEndpoints";
import { useUserStore } from "../../../../store/useUserStore";
import { StorageItems } from "../../../../utils/storageItems";
import { darkModeStepperNav } from "../../../../utils/constants";
import { useDarkModeStore } from "../../../../store/useDarkModeStore";

const SignOutIcon = () => {
    const navigate = useNavigate();
    const { setUser } = useUserStore();
    const { darkMode } = useDarkModeStore();

    const logOut = () => {
        setUser(null);
        Cookies.remove(StorageItems.TOKEN);
        Cookies.remove(StorageItems.REFRESHTOKEN);
        navigate(EndPoints.LOGIN);
    }

    return <div
        className='position-sticky d-flex align-items-center justify-content-center mb-2'
        style={{ bottom: 0, zIndex: 100, background: darkMode ? darkModeStepperNav : 'white' }}
    >
        <span
            className={`user-top-bar-item ${darkMode && 'text-white'} ps-3 pe-3`}
            role='button'
            key='Sign Out'
            onClick={logOut}
        >
            <LogoutIcon sx={{ width: '20px', height: '20px' }} />
            Sign Out
        </span>
    </div>
}

export default SignOutIcon;